import styles from './Main.module.css'
import Header from './components/Header.js';
import Loader from './components/Loader.js';
import { useState, useRef, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Grid, Scrollbar } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/grid';
import 'swiper/css/scrollbar';
import { Link } from "react-router-dom";
import background from './assets/img/background.png';
import arrow from './assets/img/arrow.svg';
import collage_photo_1 from './assets/img/collage_photo_1.jpg';
import collage_photo_2 from './assets/img/collage_photo_2.jpg';
import collage_photo_3 from './assets/img/collage_photo_3.jpg';
import collage_photo_4 from './assets/img/collage_photo_4.jpg';
import collage_photo_5 from './assets/img/collage_photo_5.jpg';

export default function Main() {
    //Флаг загрузки
    const [loading, setLoading] = useState(false);
    //Список тегов
    const [tags, setTags] = useState([]);
    //Ссылка на Swiper
    const swiperRef = useRef(null);
    //Флаги отображения стрелок
    const [showLeftArrow, setShowLeftArrow] = useState(false);
    const [showRightArrow, setShowRightArrow] = useState(false);

    //Функция установки флагов отображения стрелок
    const setArrowFlags = () => {
        setShowLeftArrow(!swiperRef.current?.swiper.isBeginning);
        setShowRightArrow(!swiperRef.current?.swiper.isEnd);
    }

    //Устанавливаем флаги отображения стрелок после загрузки Swiper`а
    useEffect(() => {
        setArrowFlags();
    }, [swiperRef, tags]);

    //Запрашиваем данные с бекенда и устанавливаем заголовок
    useEffect(() => {
        document.title = "Главная - Coperand recipes";

        //Устанавливаем флаг загрузки
        setLoading(true);

        fetch('/api/tags', {method: 'GET'})
            .then(response => response.json())
            .then(data => {
                //Сохраняем полученные данные
                if(data !== null)
                    setTags(data);
                else
                    alert("Ошибка получения тегов");

                //Сбрасываем флаг загрузки
                setLoading(false);
            })
            .catch((error) => {
                //Сбрасываем флаг загрузки
                setLoading(false);

                //Выводим информацию об ошибке
                alert("Ошибка получения тегов");
            });
    }, []);

    return (
        <>
            {loading === true && <Loader/>}
            <div className={styles.main_column}>
                <Header/>
                <main className={styles.main} style={{backgroundImage: `url(${background})`}}>
                    <h1 className={styles.main_header}>Добро пожаловать на сайт с рецептами пользователя @coperand</h1>
                    <div className={styles.main_flex}>
                        <div className={styles.left_vertical_flex}>
                            {tags.length !== 0 &&
                            <h2 className={styles.tags_header}>По тегам:</h2>
                            }
                            {tags.length !== 0 &&
                            <div className={styles.left_horizontal_flex}>
                                <img src={arrow} alt='Левая стрелка' className={styles.left_arrow} onClick={() => {swiperRef.current?.swiper.slideTo(swiperRef.current?.swiper.activeIndex - 2); setArrowFlags();}}
                                    style={showLeftArrow === true ? {"visibility": "visible"} : {"visibility": "hidden"}}></img>
                                <div className={styles.swiper_container}>
                                    <Swiper ref={swiperRef} modules={[Grid, Scrollbar]} scrollbar={{hide: false,}} slidesPerView={'auto'} grid={{rows: 3, fill: "row"}} spaceBetween={0}>
                                        {tags.map((tag, index) =>
                                            <SwiperSlide key={index} style={{width: 'auto',}}><Link to={`/recipes?tag=${tag}`}><button className={styles.tag}>{tag}</button></Link></SwiperSlide>
                                        )}
                                    </Swiper>
                                </div>
                                <img src={arrow} alt='Правая стрелка' className={styles.right_arrow} onClick={() => {swiperRef.current?.swiper.slideTo(swiperRef.current?.swiper.activeIndex + 2); setArrowFlags();}}
                                    style={showRightArrow === true ? {"visibility": "visible"} : {"visibility": "hidden"}}></img>
                            </div>
                            }
                            <Link to="/recipes"className={styles.all_button_link}><button className={styles.all_button}>Показать всё</button></Link>
                        </div>
                        <div className={styles.collage_container}>
                            <img src={collage_photo_1} alt="Фото 1 в коллаже" className={styles.collage_photo_1}></img>
                            <img src={collage_photo_2} alt="Фото 2 в коллаже" className={styles.collage_photo_2}></img>
                            <img src={collage_photo_3} alt="Фото 3 в коллаже" className={styles.collage_photo_3}></img>
                            <img src={collage_photo_4} alt="Фото 4 в коллаже" className={styles.collage_photo_4}></img>
                            <img src={collage_photo_5} alt="Фото 5 в коллаже" className={styles.collage_photo_5}></img>
                        </div>
                    </div>
                </main>
            </div>
        </>
    );
}
